// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import DrawingPath from '../DrawingPath';
import OutlinedDrawingPath from '../OutlinedDrawingPath';

const DrawingEditorSelectModeSvgStaticGroupDef = (props) => {
    const {
        paths,
        selectedPathIdsMap,
        isDragMove,
        canvasScale,
        draggedPathIdsMap,
        debugUpdateAllStrokes,
        debugDrawingLastUpdateTime,
    } = props;

    return (
        <g className="static-group">
            {paths.map((path) => {
                const { id, ...rest } = path;
                const isSelected = selectedPathIdsMap && selectedPathIdsMap[id];
                const isDraggingPath = isDragMove && draggedPathIdsMap[id];

                const pathClasses = classNames({
                    dragging: isDraggingPath,
                    selected: isSelected,
                });

                return (
                    <OutlinedDrawingPath
                        key={id}
                        canvasScale={canvasScale}
                        className={pathClasses}
                        {...rest}
                        debugUpdateAllStrokes={debugUpdateAllStrokes}
                        debugDrawingLastUpdateTime={debugDrawingLastUpdateTime}
                    />
                );
            })}
        </g>
    );
};

const DrawingEditorSelectModeSvgHitAreaGroupDef = (props) => {
    const {
        paths,
        debugUpdateAllStrokes,
        debugDrawingLastUpdateTime,
    } = props;

    return (
        <g className="hit-area">
            {paths.map((path) => {
                const { id, ...rest } = path;

                return (
                    <DrawingPath
                        key={id}
                        className="path-hit-area"
                        data-path-id={id}
                        {...rest}
                        debugUpdateAllStrokes={debugUpdateAllStrokes}
                        debugDrawingLastUpdateTime={debugDrawingLastUpdateTime}
                    />
                );
            })}
        </g>
    );
};

const DrawingEditorSelectModeSvgTransformGroupDef = (props) => {
    const {
        paths,
        selectedPathIdsMap,
        draggedPathIdsMap,
        debugUpdateAllStrokes,
        debugDrawingLastUpdateTime,
        transformGroupRef,
        isDragMove,
        canvasScale,
    } = props;

    if (!isDragMove) return null;

    return (
        <g className="transform-group" ref={transformGroupRef}>
            {paths.map((path) => {
                const { id, ...rest } = path;
                if (!draggedPathIdsMap[id]) return null;

                const pathClasses = classNames('drag-preview', {
                    selected: selectedPathIdsMap && selectedPathIdsMap[id],
                });

                return (
                    <OutlinedDrawingPath
                        key={id}
                        canvasScale={canvasScale}
                        className={pathClasses}
                        {...rest}
                        debugUpdateAllStrokes={debugUpdateAllStrokes}
                        debugDrawingLastUpdateTime={debugDrawingLastUpdateTime}
                    />
                );
            })}
        </g>
    );
};

DrawingEditorSelectModeSvgTransformGroupDef.propTypes =
    DrawingEditorSelectModeSvgHitAreaGroupDef.propTypes =
    DrawingEditorSelectModeSvgStaticGroupDef.propTypes =
        {
            paths: PropTypes.array,
            isDragMove: PropTypes.bool,

            selectedPathIdsMap: PropTypes.object,
            draggedPathIdsMap: PropTypes.object,
            debugUpdateAllStrokes: PropTypes.bool,
            debugDrawingLastUpdateTime: PropTypes.number,

            canvasScale: PropTypes.number,
            zoomScale: PropTypes.number,

            transformGroupRef: PropTypes.object,
        };

export const DrawingEditorSelectModeSvgStaticGroup = React.memo(DrawingEditorSelectModeSvgStaticGroupDef);
export const DrawingEditorSelectModeSvgHitAreaGroup = React.memo(DrawingEditorSelectModeSvgHitAreaGroupDef);
export const DrawingEditorSelectModeSvgTransformGroup = React.memo(DrawingEditorSelectModeSvgTransformGroupDef);
